module.exports = __webpack_public_path__ + "img/puzzle-disabled.3818b404.svg";